module.exports = __webpack_public_path__ + "img/05.238b4dcf.jpg";